import { render, staticRenderFns } from "./BaseStyle.vue?vue&type=template&id=de94b530&"
import script from "./BaseStyle.vue?vue&type=script&lang=js&"
export * from "./BaseStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports